import TextButton from "../TextButton";
import { ConfirmModalContent, ConfirmModalWrapper } from "./styles";
import { forwardRef } from "react";


const ConfirmModal = forwardRef(({
  title = "Are you Sure?",
  content,
  onCancel,
  onConfirm,
  modalWidth,
  style = {},
  showCancel = false,
  ...other
}, ref) => {
  return (
    <ConfirmModalWrapper $modalWidth={modalWidth} style={style} ref={ref} {...other}>
      <ConfirmModalContent>
        <div className="content">
          <p className="title">{title}</p>
          <p>{content}</p>
        </div>
        <div className="action-bar">
          {showCancel && <TextButton className="action" onClick={onCancel}>Nevermind</TextButton>}
          <TextButton className="action action-confirm" onClick={onConfirm}>Yes, I'm sure</TextButton>
        </div>
      </ConfirmModalContent>
    </ConfirmModalWrapper>
  );
});

export default ConfirmModal;
